import "./initialize";
import React from "react";
import { App } from "./App";
import { createRoot } from "react-dom/client";
import LogRocket from "logrocket";

import liff from "@line/liff";
import { configs } from "@/configs";

LogRocket.init('3arhds/fitup-v1-member-prod');
LogRocket.identify(localStorage.getItem("userId") ?? "unknown");

async function bootstrap() {
  const pathname = window.location.pathname;
  const cfg = configs.getLiffConfigByPath(pathname);
  const liffId = cfg?.liffId ?? configs.liffId;

  if (typeof liffId === "string" && liffId.trim().length > 0) {
    try {
      await liff.init({ liffId });
      console.log("LIFF initialized globally");

      if (!liff.isInClient() && !liff.isLoggedIn()) {
        liff.login();
        return;
      }
    } catch (err) {
      console.error("LIFF init failed", err);
    }
  } else {
    console.warn("Missing/invalid liffId for path:", pathname);
    await liff.init({ liffId: configs.liffId });
  }

  const root = createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

void bootstrap();